//@flow

export const hasRoles = (user: any, roles: Array<string>): boolean =>
  user.authenticated &&
  user.roles &&
  roles.some(role => user.roles.includes(role));
